import styled from "@emotion/styled";
import { Box, css, Tab, Tabs, Typography } from "@mui/material";
import { tablet } from "commons/styled.components";
import { COLORS } from "utils/colors";

export const PoliciesPageWrapper = styled(Box)`
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  padding-bottom: 220px;
`;

export const PoliciesWrapper = styled(Box)`
  padding: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  ${tablet(css`
    padding: 20px;
    border-radius: 4px;
  `)}
`;

export const PoliciesContainer = styled(Box)`
  max-width: 1000px;
  margin: 0 auto;
`;

export const StyledTabs = styled(Tabs)`
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 24px;

  .MuiTabs-indicator {
    background-color: ${COLORS.BRAND_DEFAULT_COLOR};
  }

  ${tablet(css`
    margin-bottom: 16px;
  `)}
`;

export const StyledTab = styled(Tab)`
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
  color: #666666;
  min-width: auto;

  &.Mui-selected {
    color: ${COLORS.BRAND_DEFAULT_COLOR};
  }

  ${tablet(css`
    font-size: 14px;
    padding: 10px 16px;
  `)}
`;

export const TabContent = styled(Box)`
  line-height: 1.6;
`;

export const SectionTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-top: 24px;
  margin-bottom: 12px;

  &:first-of-type {
    margin-top: 0;
  }

  ${tablet(css`
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 8px;
  `)}
`;

export const SectionDescription = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-bottom: 16px;
  line-height: 1.6;

  ${tablet(css`
    font-size: 13px;
    margin-bottom: 12px;
  `)}
`;

export const ListItem = styled.li`
  font-size: 14px;
  color: #666666;
  margin-bottom: 8px;
  line-height: 1.6;

  ${tablet(css`
    font-size: 13px;
  `)}
`;

export const UnorderedList = styled.ul`
  margin-left: 24px;
  margin-bottom: 16px;

  ${tablet(css`
    margin-left: 16px;
  `)}
`;
